import { useEffect, useRef } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Transaction } from 'components/TransactionAllocator';
import { PartnerTransfersFormValues } from '../../hooks/usePartnerTransfersForm';

type GroupedTransactions = {
  feeId: string;
  feeName: string;
  transactions: Array<Transaction>;
};

type UseInitializeFeeTransactionsProps = {
  groupedTransactions: Array<GroupedTransactions>;
  savedTransactions?: Record<string, Array<Transaction>>;
  formMethods: UseFormReturn<PartnerTransfersFormValues>;
};

export const useInitializeFeeTransactions = ({
  groupedTransactions,
  savedTransactions,
  formMethods,
}: UseInitializeFeeTransactionsProps) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) {
      return;
    }

    if (savedTransactions && Object.keys(savedTransactions).length > 0) {
      return;
    }

    if (groupedTransactions.length > 0) {
      const allTransactions: Record<string, Array<Transaction>> = {};

      for (const group of groupedTransactions) {
        allTransactions[group.feeId] = group.transactions;
      }

      if (Object.keys(allTransactions).length > 0) {
        formMethods.setValue('feeTransactions', allTransactions);
        hasInitialized.current = true;
      }
    }
  }, [groupedTransactions, savedTransactions, formMethods]);
};
